import React, { useState } from "react"
import { Box, CircularProgress, Typography } from "@mui/material"
import { OnlineModal } from "./Modals"

const ActionLoader = ({ value, isLoadingMutations }: { value: number; isLoadingMutations: boolean }) => {
    const [showOnlineModal, setShowOnlineModal] = useState(false)

    const handleClick = () => {
        setShowOnlineModal(true) // Open the modal when clicked
    }

    return (
        <>
            {isLoadingMutations && (
                <Box
                    sx={{
                        position: "fixed",
                        top: "1%",
                        right: 10,
                        display: "flex",
                        alignItems: "center",
                        zIndex: 99999,
                        cursor: "pointer",
                    }}
                    onClick={handleClick}
                >
                    <CircularProgress size={50} thickness={4} />
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                        }}
                    >
                        <Typography variant="body2" component="div" color="primary">
                            {value}
                        </Typography>
                    </Box>
                </Box>
            )}

            {/* Online Modal */}
            <OnlineModal
                open={showOnlineModal}
                isLoading={isLoadingMutations}
                handleClose={() => setShowOnlineModal(false)}
            />
        </>
    )
}

export default ActionLoader
